<template>
  <div>
    <ExpertizeShemeAddNew
      :isSidebarActive="isSidebarActiveExpertizeSidebar"
      :data="infoData"
      @closeSidebar="toggleStockExpertizeSidebar"
    />
    <vs-popup
      class="holamundo"
      :title="$t('AddExpertizeProperty')"
      :active.sync="isSidebarActiveExpertizeProperty"
      @close="closeExpertizePropertyPopup"
      @cancel="closeExpertizePropertyPopup"
    >
      <ExpertizePropertyAddNew :isSidebarActive="isSidebarActiveExpertizeProperty" :data="infoData"/>
    </vs-popup>
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="stockExpertizeDelete"
      :active.sync="isSidebarActiveProcess"
      color="danger"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row style="margin-top: 15px">
            <b-col cols="12" align-self="center">
              <h6>{{ $t("DoConfirm") }}</h6>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>
    <vs-card>
      <b-row align-h="start">
        <b-col cols="3" md="auto" style="padding-right: 2px">
          <b-col>
            <b-row align-h="end">
              <b-col cols="3" md="auto">
                <b-button
                  class="bg-warning"
                  style="border-color: white"
                  v-on:click="addStockExpertize()"
                >
                  <Icon
                    :icon="'mingcute:add-line'"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("AddNewStockExpertize") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
    </vs-card>
    <vs-card>
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="columns"
        :defaultColDef="defaultColDef"
        :rowData="processList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import i18nData from "../../i18n/i18nData";
import threeInfoButtonsDynamic from "../CellRenderers/threeInfoButtonsDynamic.vue";
import ExpertizeShemeAddNew from "./ExpertizeShemeAddNew.vue";
import ExpertizePropertyAddNew from "./ExpertizePropertyAddNew.vue";
import moment from "moment";
export default {
  data() {
    return {
      isSidebarActiveProcess: false,
      addNewInfoDataSidebar: false,
      isSidebarActiveExpertizeProperty: false,
      isSidebarActiveExpertizeSidebar: false,
      isSidebarActiveExpertizeItemSidebar: false,
      addNewActSidebar: false,
      infoData: [],
      processList: [],
      stockExpertizeData: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columns: [],
    };
  },
  components: {
    ExpertizePropertyAddNew,
    ExpertizeShemeAddNew,
    threeInfoButtonsDynamic,
    AgGridVue,
    Icon,
  },
  methods: {
    closeExpertizePropertyPopup() {
      this.isSidebarActiveExpertizeProperty = false;
    },
    addStockExpertizeItem() {
      this.isSidebarActiveExpertizeProperty = true;
    },

    toggleStockExpertizeSidebar(val = false) {
      if (val == false) {
        this.infoData = "";
        this.addInfoData();
      }
      this.isSidebarActiveExpertizeSidebar = val;
    },
    addStockExpertize() {
      this.toggleStockExpertizeSidebar(true);
    },
    closeInfoData() {
      this.addNewInfoDataSidebar = false;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    toggleActSidebar(val = false) {
      this.addNewActSidebar = val;
    },
    getStockExpertizeColumnList() {
      this.columns = [];
      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);
        this.columns.push({
          width: 150,
          pinned: "left",
          cellRendererFramework: "threeInfoButtonsDynamic",
          cellRendererParams: {
            detailMethodsOne: "stockExpertizeDetail",
            iconDetailOne: "material-symbols:edit",
            iconColorOne: "#065a82",
            tooltipOne: "Edit",
            detailMethodsTwo: "stockExpertizeDelete",
            iconDetailTwo: "ic:baseline-remove-circle",
            iconColorTwo: "#fe6d73",
            tooltipTwo: "Delete",
            detailMethodsTree: "addStockExpertizeItem",
            iconDetailTree: "clarity:rack-server-solid-badged",
            iconColorTree: "#17c3b2",
            tooltipTree: "ListStockExpertizeItem",
          },
        });
        columnList.forEach((val, index) => {
          if (val == "CompanyName") {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val.toString().includes("Date") == true)
            this.columnsProcess.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (
            val.toString().includes("Id") == false &&
            val.toString().includes("InfoType") == false
          )
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
        });
      }
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY HH:mm");
    },
    addInfoData() {
      const vs = this.$vs;

      this.$store
        .dispatch("stock/listExpertizeShema", false)
        .then((response) => {
          if (response.success == true) {
            try {
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
    stockExpertizeDelete() {
      const vs = this.$vs;
      this.$store
        .dispatch("stock/deleteExpertizeShema", this.deleteData.CheckListShemaId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.addInfoData();
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    stockExpertize: {
      get() {
        return this.$store.state.stock.StockExpertize;
      },
      set(val) {
        if (!val) {
        }
      },
    },

    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  mounted() {
    this.addInfoData();
    this.$root.$on("stockExpertizeDetail", (data) => {
      this.infoData = data;
      this.addStockExpertize(data);
    });
    this.$root.$on("addStockExpertizeItem", (data) => {
      this.infoData = data;
      this.addStockExpertizeItem();
    });
    this.$root.$on("stockExpertizeDelete", (data) => {
      this.deleteData = data;
      this.isSidebarActiveProcess = true;
    });
    this.$root.$on("closeInfoData", () => {
      this.closeInfoData();
    });
  },
  beforeDestroy() {
    this.$root.$off("stockExpertizeDetail");
    this.$root.$off("closeInfoData");
    this.$root.$off("stockExpertizeDelete");
    this.$root.$off("addStockExpertizeItem");
  },
  watch: {
    stockExpertize(val) {
      if (val.length > 0) {
        this.processList = val;
        this.getStockExpertizeColumnList();
      }

      return val;
    },
  },
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
